// MFC (Broker & Franchise) channel copy for the /mfc adviser page.
// Transcribed verbatim from "Broker registration pages (1).xlsx",
// sheet "MFC (brokers & Franchise)" — only formatting markup added.

export const MFC_FAQ_CATEGORIES = [
  {
    title: 'Validity & Security',
    faqs: [
      {
        question: 'Is creating a will online with Old Mutual valid?',
        answer:
          '<strong>A</strong>: Yes. A will created through Old Mutual is binding as long as it meets the necessary legal requirements, such as proper signing and witnessing. Clients will receive clear instructions to ensure compliance.',
      },
      {
        question:
          "How does Old Mutual ensure the security of my clients' personal information?",
        answer:
          '<strong>A</strong>: Old Mutual uses industry-leading encryption and security protocols to protect sensitive data. All personal and financial details remain confidential and are never shared without consent.',
      },
      {
        question: "Who is eligible to use Old Mutual's online will service?",
        answer:
          '<strong>A</strong>: The service is available to South African residents aged 16 years or older.',
      },
    ],
  },
  {
    title: 'Making Changes & Storage',
    faqs: [
      {
        question:
          "Can my client make changes to their will after they've created it?",
        answer:
          "<strong>A</strong>: Yes! Clients can edit their will at any time before finalizing and signing it. It's advisable to update a will after major life events such as marriage, divorce, having children, or acquiring significant assets.",
      },
      {
        question: 'Does Old Mutual charge a storage fee?',
        answer:
          '<strong>A</strong>: No. Storage and one collection of the signed will are free of charge once per year. This ensures the original will is securely stored and accessible when needed.',
      },
    ],
  },
  {
    title: 'Process & Costs',
    faqs: [
      {
        question:
          'What does it cost for my client to create a will with Old Mutual?',
        answer:
          '<strong>A</strong>: Absolutely nothing. The will drafting service is completely free.',
      },
      {
        question: 'How does the process work?',
        answer:
          '<strong>A</strong>:<br>1. The broker guides the client through the online will creation process.<br>2. The client reviews, prints, signs, and has their will witnessed as per legal requirements.<br>3. The signed will is uploaded onto the system for validation.<br>4. The signed & validated will is collected (free once per year) and securely stored by Old Mutual.',
      },
      {
        question:
          'What happens if a client does not sign or return their will?',
        answer:
          '<strong>A</strong>: If a will is not signed, it will not be valid. Brokers should encourage clients to follow through with signing and submission to complete the process. It is to the benefit of the customer to store his / her will with Old Mutual, but this is not a requirement. This is a benefit, free of charge, to the customer.',
      },
    ],
  },
  {
    title: 'Adviser Incentive & Earnings',
    faqs: [
      {
        question: 'How do I qualify for the R250 (pre-tax) incentive per will?',
        answer:
          "<strong>A</strong>:<br>The will must be validated between 1 January 2026 and 31 December 2026.<br>Only wills facilitated through registered Old Mutual brokers qualify. Payments are triggered for a client's first will on the Old Mutual Will platform. Payments will be processed after verification of each successful will submission.<br><br>Please note, the current incentive applies to MFC broker & franchise channels. Participation and incentive models for other distribution segments are underway. When confirmed, the details will be officially communicated to each channel.",
      },
      {
        question:
          'How do I register as an adviser on the Old Mutual Will platform?',
        answer:
          '<strong>A</strong>:<br>1. Click <a href="#get-registered">here</a> to register.<br>2. Complete the sign-up form and receive login details.<br>3. Start assisting clients and earning incentives.',
      },
    ],
  },
  {
    title: 'Additional Adviser Support',
    faqs: [
      {
        question: 'Can I track my submitted wills and earnings?',
        answer:
          '<strong>A</strong>: Yes, brokers will have access to a dashboard where they can track submitted wills and qualifying incentives.',
      },
      {
        question: 'Where can I get assistance if I or my clients need help?',
        answer:
          '<strong>A</strong>: Our support team is ready to assist! Contact us at:<br>• mfc@oldmutualwill.co.za<br>• 021 – 75303248<br>(Monday – Friday, 08:00 – 17:00)',
      },
    ],
  },
];

export const MFC_TERMS = [
  'The incentive will run from 1 January 2026 until 31 December 2026.',
  "To qualify for the incentive, a client's will must be validated between 1 January 2026 until 31 December 2026.",
  'Each broker can earn a maximum of R60 000 per annum from this incentive.',
  "Payments are triggered based on validation for a client's first will on the Old Mutual Will platform.",
  'MFC will make payment to the relevant advisers via Vector,',
  'All queries can be directed to Old Mutual Will via email (mfc@oldmutualwill.co.za)',
  'Please note, the current incentive applies to MFC Broker & Franchise channels. Participation and incentive models for other distribution segments are underway. When confirmed, the details will be officially communicated to each channel.',
];

export const MFC_EARNINGS_BULLET =
  "A cash incentive for each validated will from your clients, in line with the agreement with your Franchise Principle, with a maximum annual earning of R60 000 from this incentive. The incentive is triggered for a client's first will on the Old Mutual Will platform.";

export const MFC_CHANNEL_NOTE =
  'Please note, the current incentive applies to MFC brokers and franchise channels. Participation and incentive models for other distribution segments are underway. When confirmed, the details will be officially communicated to each channel.';
